<template>
  <b-row>
    <b-col
        md="2"
        sm="4"
        class="my-1"
    >

      <b-form-group
          class="mb-0"
      >
        <label class="d-inline-block text-sm-left mr-50">Per page</label>
        <b-form-select
            id="perPageSelect"
            v-model="perPage"
            size="sm"
            :options="pageOptions"
            class="w-50"
        />
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <b-table
          striped
          hover
          responsive
          :items="items"
          :fields="fields"
          @filtered="onFiltered"
          @row-clicked="clickVoucher"
      >
        <template #cell(DateTime)="data">
          {{formatDate(data.item.DateTime)}} - {{formatTime(data.item.DateTime)}} Uhr
        </template>
        <template #cell(State)="data">
          <b-badge
              pill
              variant="warning"
              v-show="data.item.State == 0"
          >
            In Warteschlange
          </b-badge>
          <b-badge
              pill
              variant="success"
              v-show="data.item.State == 1"
          >
            {{ formatDate(data.item.Send) }}
          </b-badge>
          <b-badge
              pill
              variant="danger"
              v-show="data.item.State == 2"
          >
            Unzustellbar {{ formatDate(data.item.Send) }}
          </b-badge>

        </template>
        <template #cell(Attachments)="data">
          {{getAttachmentCount(data.item.Attachments)}}
        </template>
      </b-table>
    </b-col>

    <b-col
        cols="12"
    >
      <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="center"
          size="sm"
          class="my-0"
      />
    </b-col>
  </b-row>
</template>

<script>
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BAlert, VBTooltip, BFormDatepicker,
  BDropdown,
  BDropdownDivider,
  BDropdownForm,
  BDropdownGroup,
  BDropdownItem,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BTable,
    BAvatar,
    BAlert,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BFormDatepicker,
    BInputGroupAppend,
    BButton,
    BDropdown,
    BDropdownDivider,
    BDropdownForm,
    BDropdownGroup,
    BDropdownItem,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      perPage: 50,
      pageOptions: [10, 25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      date: {
        from: '',
        to: ''
      },
      filter: null,
      filterOn: [],
      fields: [
        {
          key: 'IdentId',
          label: 'Id',
        },
        {
          key: 'DateTime',
          label: 'Datum / Zeit',
        },
        {
          key: 'PdfEventType',
          label: 'Type',
        },
        {
          key: 'Subject',
          label: 'Betreff',
        },
        {
          key: 'Voucher.Vid',
          label: 'Voucher Id',
        },
        {
          key: 'State',
          label: 'Status',
        },
      ],
      items: [{
        Costomer: 'Wird geladen....'
      }],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => ({
            text: f.label,
            value: f.key
          }))
    },

  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'Maillog'
    })
    this.LoadList()

    this.$watch(
        () => this.currentPage,
        val => {
          this.LoadList()
        },
    )

    this.$watch(
        () => this.perPage,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.LoadList()
          }, 550)
        },
    )
    this.$watch(
        () => this.filter,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.LoadList(0)
          }, 550)
        },
    )
    // Set the initial number of items
    this.totalRows = this.items.length
  },
  methods: {
    getAttachmentCount(a) {
      if(a == null)
        return 0;

      return Object.keys(a).length
    },
    formatDate(date) {
      return `${new Date(date).toLocaleString('de-DE', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          },
      )}`
    },
    formatTime(date) {
      return `${new Date(date).toLocaleString('de-DE', {
            hour: '2-digit',
            minute: '2-digit',
          },
      )}`
    },
    EnterDate(event) {
      if (event.which == 13) {
        this.LoadList()
      }
    },
    onDateFromContext(ctx) {
      if (ctx.selectedDate) {
        // The date formatted in the locale, or the `label-no - date - selected` string
        this.formatted = ctx.selectedFormatted
        // The following will be an empty string until a valid date is entered
        this.selected = ctx.selectedYMD
        this.date.from = ctx.activeFormatted
        this.LoadList()
      }
    },
    onDateToContext(ctx) {
      if (ctx.selectedDate) {
        // The date formatted in the locale, or the `label-no - date - selected` string
        this.formatted = ctx.selectedFormatted
        // The following will be an empty string until a valid date is entered
        this.selected = ctx.selectedYMD
        this.date.to = ctx.activeFormatted
        this.value = ctx.activeFormatted
        this.LoadList()
      }
    },
    clickVoucher(record, index) {
      this.$router.push({
        name: 'VoucherMask',
        params: { id: record.Vid }
      })
    },
    CreateVoucher(t) {
      this.$router.push({
        name: 'VoucherMask',
        params: { id: 0, type: t }
      })
    },
    LoadList() {
      this.items = []
      const c1 = (this.currentPage - 1) * this.perPage
      let url = `/pdf/list?from=${c1}&count=${this.perPage}`
      if (this.filter && this.filter !== '') {
        url += `&filter=${this.filter}`
      }
      this.$http.get(url)
          .then(resp => {
            this.totalRows = resp.data.info.fullEntries
            resp.data.list.forEach(i => {

              this.items.push(i.Value)
            })
          })
          .catch(err => {
            console.error(err)
          })
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>
